import React from "react";
import { useLoading } from "../../../context/loadingContext";
import GetProductTypes from "../../../functions/reference/getProductType";
import { Table, Tag } from "antd";
import { bankCodes, vatFreeGoods } from "../../../constant/bankCode";

const VatFreeProducts = () => {
  const [data, setData] = React.useState(vatFreeGoods);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 50,
      fixed: "left",
      render: (e, r, index) => index + 1,
    },
    {
      title: "Нэр",
      dataIndex: "name",
      key: "name",
      width: 200,
    },
    {
      title: "Код",
      dataIndex: "code",
      key: "code",
      width: 80,
    },
  ];
  return (
    <div>
      <Table
        scroll={{ y: "80vh" }}
        dataSource={data}
        columns={columns}
        pagination={false}
        rowKey="id"
      />
    </div>
  );
};

export default VatFreeProducts;
